<div class="container">
  <div class="hero">
    <div class="hero__content">
      <owl-carousel-o [options]="contentOptions">
        @for (slide of slideShow; track slide) {
          <ng-template carouselSlide>
            <div class="content-box">
              <img [src]="slide.image" alt="" />
              <h2>{{ slide.header }}</h2>
              @if (slide.subheader) {
                <p>{{ slide.subheader }}</p>
              }
              @if (slide.link.url || slide.link.routerLink) {
                <br />
              }
              @if (slide.link.url) {
                <a [href]="slide.link.url" target="_blank">{{
                  slide.link.text
                }}</a>
              }
              @if (slide.link.routerLink) {
                <a
                  [routerLink]="slide.link.routerLink"
                  >{{ slide.link.text }}</a
                  >
                }
              </div>
            </ng-template>
          }
          <!-- <ng-template carouselSlide>
          <div class="content-box">
            <img src="../../../assets/images/content-hero/arrow.svg" alt="" />
            <h2>Your new career starts right here</h2>
            <p>Start the search for your perfect career!</p>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="content-box">
            <img
              src="../../../assets/images/content-hero/box-heart.svg"
              alt=""
              />
              <h2>Great careers, amazing perks</h2>
              <p>We'll find your dream career. Let's get started!</p>
            </div>
          </ng-template>

          <ng-template carouselSlide>
            <div class="content-box">
              <img src="../../../assets/images/content-hero/trophy.svg" alt="" />
              <h2>Join the Number One Workplace</h2>
              <p>More than just a job, it's your future!</p>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="content-box">
              <img src="../../../assets/images/content-hero/star.svg" alt="" />
              <h2>Checkout our most popular roles</h2>
              <br />
              <a routerLink="/job-list">Click here to see what's hot!</a>
            </div>
          </ng-template> -->
        </owl-carousel-o>
      </div>
      <div class="hero__feature">
        <owl-carousel-o [options]="imageOptions">
          @for (image of filteredImages; track image) {
            <ng-template carouselSlide>
              <img [src]="image" alt="" />
            </ng-template>
          }
        </owl-carousel-o>
      </div>
      <div class="hero__search">
        <div class="search-holder">
          <input
            type="text"
            placeholder="Search for roles, location, or categories"
            [(ngModel)]="searchText"
            (keyup.enter)="search()"
            />
            <span class="hero-search-button fa-stack fa-3x" (click)="search()">
              <i class="fa-solid fa-circle fa-stack-2x"></i>
              <i class="fa-solid fa-search fa-stack-1x fa-inverse"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
